<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-add-button/course-add-button.component.ts.CourseAddButtonComponent.html